import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1d27932"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "when-at-home"
}
const _hoisted_2 = { class: "h4 when-at-home__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon when-at-home__next-button--icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createVNode(_component_RadioGroup, {
          modelValue: _ctx.selectedOption,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
          class: "when-at-home__options",
          options: _ctx.whenAtHomeOptions
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_AppButton, {
          class: "when-at-home__next-button",
          "full-width": "",
          disabled: !_ctx.selectedOption,
          size: "large",
          onClick: _ctx.next
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextButton), 1),
            _hoisted_3
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}